'use strict';
import isFunction from 'lodash/isFunction';
import * as T from 'prop-types';
import React from 'react';
import {componentFromStream, createEventHandler} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import {ButtonState, isButtonState} from '../../../core-utilities/enums/ButtonState';
import {createToggleState} from '../../../core-utilities/react-utils';
import {CreateCardView} from './CreateCardView';


export const CreateCardHOC = (WrappedComponent, childProps = {}) => {
  const StreamedComponent = componentFromStream(props$ => {
    const {
      handler: onTriggerSave,
      stream: triggerSave$,
    } = createEventHandler();

    const {
      handler: onToggleShowForm,
      stream: showForm$,
    } = createToggleState(props$);

    props$
      .map(props => props.triggerReset$)
      .filter(triggerReset$ => triggerReset$ && isFunction(triggerReset$.subscribe))
      .distinctUntilChanged()
      .switchMap(triggerReset$ => triggerReset$)
      .withLatestFrom(showForm$)
      .filter(([_, showForm]) => !!showForm)
      .takeUntil(props$.last())
      .subscribe(onToggleShowForm);

    return props$
      .combineLatest(
        showForm$,
        (props, showForm) => (
          <CreateCardView
            className={props.className}
            mode={props.mode}
            isModal={props.isModal}
            showForm={showForm}
            onHideForm={onToggleShowForm}
            onShowForm={onToggleShowForm}
            onTriggerSave={onTriggerSave}
            modalHeaderLabel={props.modalHeaderLabel}
            placeholderLabel={props.placeholderLabel}
            placeholderLabelClass={props.placeholderLabelClass}
            svgIcon={props.svgIcon}
          >
            <WrappedComponent
              model={null}
              isEditing={true}
              isSaving={props.mode !== ButtonState.START}
              onSave={props.onSave}
              triggerSave$={triggerSave$}
              {...childProps}
            />
          </CreateCardView>
        ));
  });

  StreamedComponent.propTypes = {
    className: T.string,
    placeholderLabelClass: T.string,
    mode: isButtonState,
    isModal: T.bool,
    triggerReset$: T.object,
    onSave: T.func,
    modalHeaderLabel: T.node,
    placeholderLabel: T.node,
  };

  return StreamedComponent;
};



// WEBPACK FOOTER //
// ./src/js/components/lists/CreateCard/CreateCardComponent.js